export const getKeysOfNotNullValues = obj => Object.keys(obj)
.filter(k => obj[k] !== null);
